import React from "react";
const Q2 = () => {
  return (
    <div style={{ backgroundColor: "#Dbe6ea" }}>
      <div className="ans-bank">
        <div className="qta">Any Disputes?</div>
        <p>
          THIS Giveaway IS GOVERNED BY THE LAWS OF INDIA, WITHOUT RESPECT TO
          CONFLICT OF LAW DOCTRINES. The Entrant agrees, as a condition of
          participating in this promotion, that if any disputes cannot be
          resolved between the Entrant and the Sponsor, and if causes of action
          arise out of or are connected with this Giveaway, they shall be
          individually resolved exclusively before a court having jurisdiction,
          without resorting to any form of class action. Under no circumstances
          in any such dispute shall the participant be permitted to obtain
          awards for, and hereby waives all rights to, punitive, incidental, or
          consequential damages, including reasonable attorney’s fees, other
          than participant’s actual out-of-pocket expenses (i.e. costs
          associated with entering this Giveaway). The participant waives all
          rights to have damages multiplied or increased.
        </p>
      </div>
    </div>
  );
};

export default Q2;
